import type { BrowserSession, MediaTrack, PublishOptions } from "@hololive/browser-sdk";

type ScreenSession = Pick<BrowserSession, "capture" | "publish" | "unpublish">;

export interface ScreenShareResult {
  tracks: MediaTrack[];
  hasSystemAudio: boolean;
}

export async function publishScreenShare(session: ScreenSession, includeSystemAudio: boolean, onCaptured?: (tracks: MediaTrack[]) => void, audioOptions: PublishOptions = {}): Promise<ScreenShareResult> {
  const tracks = await session.capture({ screen: true, screen_audio: includeSystemAudio });
  onCaptured?.(tracks);
  try {
    for (const track of tracks) await session.publish(track, track.kind === "audio" ? audioOptions : {});
    return { tracks, hasSystemAudio: tracks.some((track) => track.kind === "audio" && track.source === "screen") };
  } catch (error) {
    await Promise.all(tracks.map((track) => session.unpublish(track.track_id).catch(() => undefined)));
    throw error;
  }
}

export async function unpublishScreenShare(session: ScreenSession, tracks: MediaTrack[], onError: (error: unknown) => void): Promise<void> {
  await Promise.all(tracks.map((track) => session.unpublish(track.track_id).catch(onError)));
}
